export default {
  add: `mutation addUser($name: String!, $email: String!, $office: Int!, $role: Int!) {
          addUser(
            name: $name,
            email: $email,
            status: true,
            office: $office,
            role: $role,
          ) {
            id,
            name,
            email,
            office,
            role,
            isFirstLogged,
            officeInfo {
              id
              name
            },
            dietsInfo {
              id
              name
            },
          }
        }`,
  addUserDiet: `mutation addUserDiet($user: String!, $diet: Int!) {
          addUserDiet(
            user: $user,
            diet: $diet,
          ) {
            user,
            diet
          }
        }`,
  updateIsFirstLogged: `mutation updateIsFirstLogged($email: String!, $isFirstLogged: Boolean!) {
            updateIsFirstLogged(
              email: $email,
              isFirstLogged: $isFirstLogged,
            ) {
              updated
          }
        }`,
  updateUserOffice: `mutation updateUsersOffice($email: String!, $office: Int!) {
            updateUsersOffice(
            email: $email,
            office: $office,
          ) {
            updated
        }
      }`,
  deleteUserDiet: `mutation deleteUserDiet($user: String!, $diet: Int!) {
    deleteUserDiet(
          user: $user,
          diet: $diet,
        ) {
          destroyed
      }
    }`,
  setUserAllergies: `mutation setUserAllergies($user: String!, $allergies: [Int!]!) {
    setUserAllergies(
            user: $user,
            allergies: $allergies,
          ) {
            updated
        }
      }`,
  createUsers: `mutation createUsers($users: [UserInput!]!) {
    createUsers(
            users: $users,
          ) {
            id,
            name,
            email,
        }
    }`,
};



// WEBPACK FOOTER //
// ./src/graphql/mutations/user.js